import {makeAutoObservable} from 'mobx';

export type GlobalTabBarItem = {
  closeCallback?: () => void;
  id: string;
  pathname: string;
  lastVisitedPath?: string;
  text: string;
  tooltipContent?: string;
  tooltipHeader?: string;
  width?: number;
};

export class TabBarStore {
  public tabBarItems: GlobalTabBarItem[] = [];

  public constructor() {
    makeAutoObservable(this, {}, {autoBind: true});
  }

  public getTabById(tabBarItemId: string): GlobalTabBarItem | undefined {
    return this.tabBarItems.find(({id}) => id === tabBarItemId);
  }

  public getTabByPathname(
    currentPathname: string
  ): GlobalTabBarItem | undefined {
    return this.tabBarItems.find(({pathname}) =>
      currentPathname.startsWith(pathname)
    );
  }

  public addTabBarItem(newTab: GlobalTabBarItem): void {
    this.tabBarItems.push(newTab);
  }

  public removeTabBarItem(tabBarItemId: string): void {
    this.tabBarItems = this.tabBarItems.filter(
      (tabBarItem) => tabBarItem.id !== tabBarItemId
    );
  }

  public updateTabBarItem(updatedTab: GlobalTabBarItem): void {
    this.tabBarItems = this.tabBarItems.map((tabBarItem) =>
      tabBarItem.id === updatedTab.id ? updatedTab : tabBarItem
    );
  }

  public clearTabBarItems(): void {
    this.tabBarItems = [];
  }
}
